<template>
	<div v-show="!showModal">
		<a-spin :spinning="loading">
			<a-form ref="form" :model="formState" name="form" @finish="onSearch">
				<a-row>
					<a-form-item class="ui-form__item" name="organizationId" label="影院组织">
						<a-select placeholder="请选择" v-model:value="formState.organizationId" style="width: 180px;"
							@change="getAllCinemaList">
							<!-- <a-select-option :value="0">全部</a-select-option> -->
							<a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
								{{ item.name }}</a-select-option>
						</a-select>
					</a-form-item>

					<a-form-item class="ui-form__item" name="cinemaId" label="所属影院">
						<a-select placeholder="请选择" v-model:value="formState.cinemaId" style="width: 180px;">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
								{{ item.name }}</a-select-option>
						</a-select>
					</a-form-item>
				</a-row>

				<a-row>
					<a-col :span="18">
						<a-button v-permission="['system_warn_mobileWarn_add']" type="primary" @click="onAdd">新增预警</a-button>
					</a-col>
					<a-col :span="6" style="text-align: right;">
						<a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
						<a-button @click="reset">重置</a-button>
					</a-col>
				</a-row>
			</a-form>

			<div style="margin-top: 20px;">
				<a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="list"
					:scroll="{ x: 1100 }">
					<template #bodyCell="{ column, record, index }">
						<template v-if="column.key === 'time'">
							<div v-if="record.timeList">
								<div style="margin-bottom: 10px;" v-for="(item, itemIndex) in JSON.parse(record.timeList)" :key="itemIndex">
									<div>{{ transDateTime(item.startTime) }}</div>
									-
									<div>{{ transDateTime(item.endTime) }}</div>
								</div>
							</div>
							<div v-else>-</div>
						</template>
						<template v-if="column.key === 'isTicketMode'">
							<div>{{ record.isTicketMode ? '是' : '否' }}</div>
						</template>
						<template v-if="column.key === 'isDisabled'">
							{{ record.isDisabled ? '已关闭预警' : '已开启预警' }}
						</template>
						<template v-if="column.key === 'action'">
							<a-dropdown :trigger="['click', 'hover']">
								<a-button @click.prevent>操作 <Icon icon="DownOutlined"></Icon>
								</a-button>
								<template #overlay>
									<a-menu>
										<div @click="onSee(record)">
											<a-menu-item>
												查看
											</a-menu-item>
										</div>
										<div v-permission="['system_warn_mobileWarn_edit']" @click="onEdit(record)">
											<a-menu-item>
												编辑
											</a-menu-item>
										</div>
										<div v-permission="['system_warn_mobileWarn_isDisabled']" v-if="record.isDisabled" @click="onDisabled(record)">
											<a-menu-item>
												开启预警
											</a-menu-item>
										</div>
										<div v-permission="['system_warn_mobileWarn_isDisabled']" v-else @click="onDisabled(record)">
											<a-menu-item>
												关闭预警
											</a-menu-item>
										</div>
										<!-- <div @click="onDelete(record)">
											<a-menu-item>
												删除
											</a-menu-item>
										</div> -->
									</a-menu>
								</template>
							</a-dropdown>
						</template>
					</template>
				</a-table>
			</div>
		</a-spin>
	</div>
	<temp v-if="showModal" :isEdit="isEdit" :isSee="isSee" :id="id" @back="onBack"></temp>
</template>

<script>
	import temp from './temp.vue';
	import {
		Icon
	} from '@/components/icon/icon.js';
	import {
		getShareQR
	} from '@/service/modules/advert.js';
	import {
		getOrganizationList,
		getCinemaList,
		getCinemaWarn,
		disabledCinemaWarn
	} from '@/service/modules/cinema.js';
	export default {
		components: {
			Icon,
			temp
		},
		data() {
			return {
				loading: false,
				isEdit: false,
				isSee: false,
				id: 0,
				storeId: 0,
				organizationList: [],
				cinemaAllList: [],
				formState: {
					// organizationId: 0,
					cinemaId: 0,
				},
				searchData: {},
				showModal: false,
				list: [],
				columns: [{
						title: '预警影院',
						dataIndex: 'cinemaName',
						width: 250
					}, {
						title: '预警时间段(放映时间)',
						key: 'time',
						width: 200
					}, {
						title: '预警手机号',
						dataIndex: "warnPhone",
						width: 280
					}, {
						title: '预警手机号归属地',
						dataIndex: 'phoneAttribute',
						width: 300
					}, {
						title: '接收预警短信手机号',
						dataIndex: 'receivePhone',
						width: 280
					}, {
						title: '是否票务系统出票',
						key: 'isTicketMode',
						width: 150
					}, {
						title: '状态',
						key: 'isDisabled',
						width: 120
					}, {
						title: '操作',
						key: 'action',
						width: 100,
						fixed: 'right'
					}
				],
				pagination: {
					showSizeChanger: true,
					showQuickJumper: true,
					size: "middle",
					showTotal: (total) => {
						return "共 " + total + " 条";
					},
					total: 0,
					current: 1,
					pageSize: 10,
					onChange: (page) => {
						this.pagination.current = page;
						this.getData();
					},
					onShowSizeChange: (page, pageSize) => {
						this.pagination.current = 1;
						this.pagination.pageSize = pageSize;
						this.getData();
					}
				},
				showAddPopup: false,
			}
		},
		created() {
			this.getOrganizationList();
			// this.getAllCinemaList();
		},
		methods: {
			onBack(isRef) {
				this.showModal = false;
				if (isRef) {
					this.$nextTick(() => {
						this.getData();
					})
				}
			},
			onSearch() {
				this.pagination.current = 1;
				this.searchData = JSON.parse(JSON.stringify(this.formState));
				this.searchData.organizationId = this.searchData.organizationId ? this.searchData.organizationId : undefined;
				this.searchData.cinemaId = this.searchData.cinemaId ? this.searchData.cinemaId : undefined;
				this.getData();
			},
			reset() {
				this.$refs.form.resetFields();
				if (this.organizationList.length) {
					this.formState.organizationId = this.organizationList[0].id;
					this.getAllCinemaList(this.formState.organizationId);
				}
				this.onSearch();
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getCinemaWarn({
						page: this.pagination.current,
						pageSize: this.pagination.pageSize,
						...this.searchData
					})
					this.loading = false;
					if (ret.code === 200) {
						this.list = ret.data.list;
						this.pagination.total = ret.data.totalCount;
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getOrganizationList() {
				this.loading = true;
				try {
					let ret = await getOrganizationList({
						page: 1,
						pageSize: 999999
					});
					if (ret.code === 200) {
						this.organizationList = ret.data.list;
						if (this.organizationList.length) {
							this.formState.organizationId = this.organizationList[0].id;
							this.getAllCinemaList(this.formState.organizationId);
						}
						this.getData();
					} else {
						this.loading = false;
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getAllCinemaList(organizationId) {
				this.cinemaAllList = [];
				this.formState.id = 0;
				let ret = await getCinemaList({
					page: 1,
					pageSize: 999999,
					organizationId: organizationId ? organizationId : undefined
				})
				if (ret.code === 200) {
					this.cinemaAllList = ret.data.list;
				}
			},
			onDisabled(item) {
				this.$confirm({
					title: '提示',
					content: '确定' + (item.isDisabled ? '开启' : '关闭') + '该预警吗？',
					onOk: async () => {
						this.loading = true;
						try {
							let ret = await disabledCinemaWarn({
								id: item.id,
								isDisabled: item.isDisabled ? 0 : 1
							})
							this.loading = false;
							if (ret.code === 200) {
								this.$message.success((item.isDisabled ? '开启' : '关闭') + '成功');
								this.getData();
							}
						} catch(e) {
							console.log(e)
							this.loading = false;
						}
					}
				})
			},
			onAdd() {
				this.isEdit = false;
				this.id = 0;
				this.isSee = false;
				this.showModal = true;
			},
			onEdit(item) {
				this.isEdit = true,
				this.id = item.id;
				this.isSee = false;
				this.showModal = true;
			},
			onSee(item) {
				this.isEdit = true,
				this.id = item.id;
				this.isSee = true;
				this.showModal = true;
			},
		}
	}
</script>

<style>
	.ui-form__item {
		margin-right: 30px;
	}
</style>